export enum Routes {
    LoginAppSellWith = "/login/app/sellwith",
    LoginAppBuyWith = "/login/app/buywith",
    LoginAdmin = "/login/admin",
    LoginAppSellWithLimitedUser = "/login/app/sellwith?register=limited_user",
    LoginAppBuyWithLimitedUser = "/login/app/buywith?register=limited_user"
  }